// components/Sidebar.js
import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons"
import classNames from "classnames"

import logo from "../../../assets/fribl-LOGO-white-aug23.svg"
import {
  GeneralSettingsSidebar,
  JobMatchSidebar,
  MatchesPageSidebar,
} from "./components"

// Redux
import { selectIsFreemiumUser } from "../../../redux/selectors/selectIsFreemiumUser"

const Sidebar = () => {
  const auth = useSelector((state) => state.auth)
  const { pathname } = useLocation()
  const sidebarRef = useRef(null);
  const navigate = useNavigate()

  useEffect(() => {
    // Scroll to top when switching between matches and candidates
    if (pathname.includes("/matches") && sidebarRef.current) {
      sidebarRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname]);

  const isPremium = !useSelector(selectIsFreemiumUser); // TODO: find a better way to determine if user is Premium
  // const isEnterprise = auth?.onboardingStage === "Enterprise";

  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const [showJobMatchSidebar, setShowJobMatchSidebar] = useState(true)

  const showMatchesPageSidebar =
    pathname.includes("/matches") ||
    (pathname.includes("/candidates") && pathname.includes("/job-match"))


  const shouldShowJobMatchSidebar = showJobMatchSidebar && !pathname.includes("/buy-more");

  const firstName = auth?.user?.name?.split(" ")[0]

  const generalSettingsHandleBack = () => {
    setShowJobMatchSidebar(true);
    navigate("/job-match/select-cv");
  }

  const content = showMatchesPageSidebar ? (
    <MatchesPageSidebar key={"SIDEBAR"} />
  ) : shouldShowJobMatchSidebar ? (
    <JobMatchSidebar showFilters={!pathname.includes("/job-spec") && !pathname.includes("/select-cv/")} />
  ) : (
    <GeneralSettingsSidebar back={generalSettingsHandleBack} />
  )

  return (
    <div className="sidebar" ref={sidebarRef}>
      <div className="sidebar__imagecontainer">
        <Link to={"/job-match/select-cv"}>
          <img src={logo} alt="logo" className="sidebar__logo" />
        </Link>

        {!showMatchesPageSidebar && (
          <button
            className={classNames("sidebar__user-icon sidebar__user-icon--desktop", {
              "sidebar__user-icon--premium": isPremium,
              // "sidebar__user-icon--enterprise": isEnterprise,
            })}
            onClick={() => setShowJobMatchSidebar((prev) => !prev)}
          >
            {firstName}&nbsp;{userSvg(isPremium)}
          </button>
        )}

        {/* Hamburger */}
        <div
          className="sidebar__toggle"
          role={"button"}
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <FontAwesomeIcon icon={faBars} color="white" size={"2x"} />
        </div>
      </div>

      <div className="sidebar__content">{content}</div>

      <div
        className={classNames("sidebar__backdrop", {
          "sidebar__backdrop--visible": showMobileMenu,
        })}
        onClick={() => setShowMobileMenu(false)}
      />

      <div
        onClick={() => setShowMobileMenu(false)}
        className={classNames("sidebar__content-mobile", {
          "sidebar__content-mobile--visible": showMobileMenu,
        })}
      >
        <div className="sidebar__mobile-header">
          <Link to={"/"}>
            <img src={logo} className="sidebar__logo" alt="logo" />
          </Link>

          {!showMatchesPageSidebar && (
            <button
              className={classNames("sidebar__user-icon sidebar__user-icon--mobile", {
                "sidebar__user-icon--premium": isPremium,
                // "sidebar__user-icon--enterprise": isEnterprise,
              })}
              onClick={(e) => {
                e.stopPropagation()
                setShowJobMatchSidebar((prev) => !prev)
              }}
            >
              {firstName}&nbsp;{userSvg(isPremium)}
            </button>
          )}

          <div
            className="sidebar__toggle"
            role={"button"}
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            <FontAwesomeIcon icon={faClose} color="white" size={"2x"} />
          </div>
        </div>

        {content}
      </div>
    </div>
  )
}

const userSvg = (isPremium) => {
  const fillColor = isPremium ? "#5ec58f" : "none";
  const strokeColor = isPremium ? "#5ec58f" : "#18A8D5";

  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 19.5V17.5C17 16.4391 16.5786 15.4217 15.8284 14.6716C15.0783 13.9214 14.0609 13.5 13 13.5H5C3.93913 13.5 2.92172 13.9214 2.17157 14.6716C1.42143 15.4217 1 16.4391 1 17.5V19.5M13 5.5C13 7.70914 11.2091 9.5 9 9.5C6.79086 9.5 5 7.70914 5 5.5C5 3.29086 6.79086 1.5 9 1.5C11.2091 1.5 13 3.29086 13 5.5Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Sidebar
